// 軽量 classnames 連結。条件付きクラスの合成に使う（外部依存なし）。
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
